import type { AuthenticatedUser } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const getCurrentUser = async (): Promise<AuthenticatedUser> => {
  const response = await apiClient.get<AuthenticatedUser>('/me');
  return response.data;
};
